import { render, staticRenderFns } from "./IconPromo.vue?vue&type=template&id=5349d134"
import script from "./IconPromo.vue?vue&type=script&lang=js"
export * from "./IconPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports